import { FallbackStyleContainer } from '@kpa/kul';
import React, { FC, ReactNode } from 'react';
import Content from './Content';
import { XhtmlResponse } from './types/shared';

interface IXhtmlText {
  xhtmlResponse: XhtmlResponse;
}

const XhtmlText: FC<IXhtmlText> = ({ xhtmlResponse }): ReactNode => {
  return xhtmlResponse.fragments && xhtmlResponse.fragments
    .map(
      (fragment, index) => (
        <React.Fragment key={index}>
          {fragment.rawXhtml && <FallbackStyleContainer innerHtml={fragment.rawXhtml} />}
          {fragment.content && <Content content={fragment.content} />}
        </React.Fragment>
      ),
    );
};

export default XhtmlText;
